import { COLORS } from '@btime/constants'
import React from 'react'

import { Progress } from '@ant-design/plots'

import { useColor } from '../../../../../../packages/kiti/components/theme/_hooks/colors'

const ProgressBar = ({ color, presentation, value, all }) => {
  color = useColor(color, 'dark5')

  if (presentation !== 'bar') return false
  const percent = value / all
  if (isNaN(percent)) return false

  const config = {
    height: 7,
    autoFit: false,
    percent,
    color: [color, COLORS.light2]
  }

  return <Progress {...config} />
}

export default ProgressBar
